import React, { useState } from "react";
import ContactSection from "../components/ContactSection";
import { useNavigate } from "react-router-dom";
import InsightImage from '../assets/insights_image.png';
import Phase1 from "../pages/phases/Phase1";
import Phase2 from "../pages/phases/Phase2";
import Phase3 from "../pages/phases/Phase3";
const PHASES = [
  {
    num: "01",
    id: "phase-1",
    label: "Phase 1: Social Media Marketing Strategy",
    component: <Phase1 />,
  },
  {
    num: "02",
    id: "phase-2",
    label: "Phase 2: Meta Advertising Campaign Architecture",
    component: <Phase2 />,
  },
  {
    num: "03",
    id: "phase-3",
    label: "Phase 3: Google My Business Optimization",
    component: <Phase3 />,
  },
  // {
  //   num: "04",
  //   id: "phase-4",
  //   label: "Integration & Funnel Optimization",
  //   component: <Phase4 />,
  // },
  // {
  //   num: "05",
  //   id: "phase-5",
  //   label: "Results & Performance Metrics",
  //   component: <Phase5 />,
  // },
  // {
  //   num: "06",
  //   id: "phase-6",
  //   label: "Strategic Learnings & Optimization Insights",
  //   component: <Phase6 />,
  // },
  // {
  //   num: "07",
  //   id: "phase-7",
  //   label: "User Generated Content (UGC) Strategy",
  //   component: <Phase7 />,
  // },
  // {
  //   num: "08",
  //   id: "phase-8",
  //   label: "Ongoing Optimization & Scaling",
  //   component: <Phase8 />,
  // },
];

export default function CaseStudy() {

  const navigate = useNavigate();
  const [activeId, setActiveId] = useState("phase-1");



   const currentIndex = PHASES.findIndex(
    (p) => p.id === activeId
  );

  const currentPhase = PHASES[currentIndex];
  const nextPhase = PHASES[currentIndex + 1];

  const handleSidebarClick = (id) => (e) => {
    e.preventDefault();
    setActiveId(id);
  };


  // const handleSidebarClick = (id) => (e) => {
  //   setActiveId(id);
  //   const target = document.getElementById(id);
  //   if (target) {
  //     e.preventDefault();
  //     target.scrollIntoView({ behavior: "smooth", block: "start" });
  //     // keep the URL hash in sync without an extra jump
  //     window.history.pushState(null, "", `#${id}`);
  //   }
  // };

  return (
    <div className="cs-root">
      <style>{css}</style>

      {/* Title block */}
      <header className="cs-title-block">
        <h1 className="cs-h1">
          Case Study: Precision Lead Generation for Aruh Koncepts Interior
          Design Studio
        </h1>
        <p className="cs-sub">
          How Grownex transformed lead quality for a premium interior design
          studio — from 5% to 71% qualification rate through
          precision-targeted Meta advertising, social media marketing, and
          Google My Business optimization.
        </p>

        {/* <a className="cs-back-link" href="#insights">
          ← Back to Insights
        </a> */}

        <div className="cs-meta-row">
          <span className="cs-tag-pill">Case Study</span>
          <span className="cs-meta-text">Feb 20, 2025</span>
          <span className="cs-meta-dot">·</span>
          <span className="cs-meta-text">25 min read</span>
        </div>
      </header>

      {/* Hero image */}
      <div className="cs-hero-img-wrap">
        <img
          className="cs-hero-img"
          src={InsightImage}      alt="insights image"
        />
      </div>

      <div className="cs-container">
        {/* Client & Market Context */}
        <section className="cs-section">
          <h2 className="cs-h2">Client &amp; Market Context</h2>
          <p className="cs-p">
            Aruh Koncepts is a premium interior design studio based in
            Hyderabad, India, specializing in high-end residential and
            commercial interior projects. Operating in a competitive market
            where interior design services range from budget contractors to
            luxury studios, Aruh Koncepts needed to establish distinct market
            positioning and generate qualified leads from clients capable of
            investing in premium design services.
          </p>
          <p className="cs-p">
            The Hyderabad interior design market presents unique challenges:
            extreme lead quality variation with high volumes of unqualified
            inquiries, price-sensitive market dominated by budget-focused
            buyers, difficulty differentiating premium services in crowded
            digital landscape, and long sales cycles requiring sustained
            engagement and trust-building.
          </p>
          <p className="cs-p">
            Aruh Koncepts required a strategic digital marketing approach
            that would generate high-quality leads, eliminate junk
            inquiries, establish brand authority, and create predictable
            client acquisition flow.
          </p>
        </section>

        {/* Strategic Challenge */}
        <section className="cs-section">
          <h2 className="cs-h2">Strategic Challenge</h2>
          <p className="cs-p">
            Previous marketing efforts had generated volume but poor
            conversion rates. The studio was receiving 50-70 monthly leads
            through basic Meta advertising, but less than 5% qualified as
            serious prospects with appropriate budgets and project scope.
            Sales team time was consumed filtering unqualified inquiries, and
            customer acquisition costs were unsustainable relative to
            project values.
          </p>
          <p className="cs-p">
            The fundamental challenge: attract premium clients willing to
            invest in professional design services while systematically
            excluding budget shoppers, DIY enthusiasts, and information
            seekers who would never convert.
          </p>
        </section>

        {/* Strategic Framework */}
        <section className="cs-section">
          <h2 className="cs-h2">Strategic Framework</h2>
          <p className="cs-p">
            Grownex developed an integrated digital marketing strategy
            across Social Media Marketing, Meta Advertising, and Google My
            Business, with precision targeting and content strategy aligned
            with Meta's Andromeda algorithm update to maximize qualified
            lead generation.
          </p>
        </section>

        {/* Deep Dive */}
        <section className="cs-deepdive">
          <p className="cs-eyebrow">Deep Dive</p>

          <div className="cs-deepdive-grid">
            <nav className="cs-sidebar" aria-label="Case study phases">
              {PHASES.map((p) => (
                <SidebarItem
                  key={p.id}
                  num={p.num}
                  href={`#${p.id}`}
                  active={activeId === p.id}
                  onClick={handleSidebarClick(p.id)}
                >
                  {p.label}
                </SidebarItem>
              ))}
            </nav>


            <div className="cs-deepdive-content">

  {currentPhase.component}

  <div className="cs-divider" />

  {nextPhase && (
    <button
      className="cs-next-phase"
      onClick={() => setActiveId(nextPhase.id)}
    >
      {nextPhase.label} →
    </button>
  )}

</div>
          </div>
        </section>

        <div className="cs-divider cs-divider-full" />

        {/* mini CTA bar */}
        <section className="cs-mini-cta">
          <div>
            <p className="cs-mini-cta-title">
              Want results like these for your business?
            </p>
            <p className="cs-mini-cta-sub">Let's discuss your growth strategy.</p>
          </div>
          <button type="button" className="cs-mini-cta-btn" onClick={() => navigate("/contact")}>
            Get in touch
          </button>
        </section>
      </div>

      <ContactSection />
    </div>
  );
}

function SidebarItem({ num, children, active, href, onClick }) {
  return (
    <a
      href={href}
      onClick={onClick}
      className={`cs-phase-item${active ? " is-active" : ""}`}
      aria-current={active ? "true" : undefined}
    >
      <span className="cs-phase-num">{num}</span>
      <span className="cs-phase-label">{children}</span>
    </a>
  );
}

const css = `
  .cs-root {
    background: #ffffff;
    color: #18181b;
    // font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  }
  .cs-root * { box-sizing: border-box; }

  .cs-container {
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 40px;
  }

  /* ---------- Title block ---------- */
  .cs-title-block {
    max-width: 1180px;
    margin: 0 auto;
    padding: 56px 40px 28px;
  }
  .cs-h1 {
    font-size: clamp(26px, 3.4vw, 44px);
    font-weight: 800;
    line-height: 1.2;
    margin: 0 0 16px;
    letter-spacing: -0.01em;
    max-width: 1000px;
  }
  .cs-sub {
    font-size: 17px;
    line-height: 1.6;
    color: #737373;
    max-width: 780px;
    margin: 0 0 28px;
  }
  .cs-back-link {
    display: inline-block;
    font-size: 14px;
    color: #18181b;
    text-decoration: none;
    margin-bottom: 20px;
  }
  .cs-back-link:hover { text-decoration: underline; }

  .cs-meta-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .cs-tag-pill {
    background: #FCE4D9;
    color: #EE5B26;
    font-size: 13px;
    font-weight: 600;
    padding: 5px 14px;
    border-radius: 999px;
  }
  .cs-meta-text { font-size: 13px; color: #9a9a9e; }
  .cs-meta-dot { color: #c7c7cb; }

  /* ---------- Hero image ---------- */
  .cs-hero-img-wrap {
    max-width: 1180px;
    image
    height:700px;
    margin: 0 auto 50px;
    object-fit: contain;
    padding: 0 40px;
  }
  .cs-hero-img {
    width: 100%;
    display: block;
    height: clamp(220px, 38vw, 460px);
    object-fit: cover;
    border-radius: 4px;
  }

  /* ---------- Sections ---------- */
  .cs-section { padding-bottom: 44px; }
  .cs-h2 {
    font-size: clamp(20px, 2.2vw, 26px);
    font-weight: 700;
    margin: 0 0 18px;
    letter-spacing: -0.01em;
  }
  .cs-h2-tight { margin-bottom: 22px; }
  .cs-h3 {
    font-size: 17px;
    font-weight: 700;
    margin: 26px 0 10px;
  }
  .cs-p {
    font-size: 15.5px;
    line-height: 1.75;
    color: #54545a;
    margin: 0 0 16px;
    max-width: 880px;
  }

  /* ---------- Deep dive ---------- */
  .cs-deepdive { padding-bottom: 16px; }
  .cs-eyebrow {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9a9a9e;
    margin: 0 0 24px;
  }
  .cs-deepdive-grid {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 56px;
    align-items: start;
  }
  .cs-sidebar {
    display: flex;
    flex-direction: column;
    gap: 14px;
    position: sticky;
    top: 24px;
  }
  .cs-phase-item {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    font-size: 14px;
    color: #54545a;
    line-height: 1.4;
    padding: 10px 14px;
    border-radius: 8px;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  .cs-phase-item:hover {
    background: #F5F5F6;
    color: #18181b;
  }
  .cs-phase-item.is-active {
    background: #FCE4D9;
    color: #EE5B26;
    font-weight: 600;
  }
  .cs-phase-item.is-active:hover {
    background: #FCE4D9;
    color: #EE5B26;
  }
  .cs-phase-num {
    font-size: 12px;
    color: #b5b5ba;
    flex-shrink: 0;
    min-width: 16px;
  }
  .cs-phase-item.is-active .cs-phase-num { color: #EE5B26; }

  .cs-phase-anchor {
    scroll-margin-top: 24px;
  }

  .cs-divider {
    border-top: 1px solid #ECECEE;
    margin: 28px 0 0;
  }
  .cs-divider-full { margin: 0 0 40px; }

  .cs-next-phase {
    display: flex;
    text-align: right;
    font-size: 14px;
    font-weight: 600;
    color: #EE5B26;
    text-decoration: none;
    padding-top: 18px;
    cursor: pointer;
  }
  .cs-next-phase:hover { text-decoration: underline; }

  /* ---------- Mini CTA bar ---------- */
  .cs-mini-cta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding-bottom: 64px;
    flex-wrap: wrap;
  }
  .cs-mini-cta-title { font-size: 16px; font-weight: 500; margin: 0 0 4px; color: #18181b; }
  .cs-mini-cta-sub { font-size: 14px; color: #9a9a9e; margin: 0; }
  .cs-mini-cta-btn {
    background: #EE5B26;
    color: #fff;
    border: none;
    font-size: 14px;
    font-weight: 600;
    padding: 14px 30px;
    border-radius: 999px;
    cursor: pointer;
    white-space: nowrap;
  }
  .cs-mini-cta-btn:hover { background: #d94f1d; }

  /* ====================== TABLET ====================== */
  @media (max-width: 1024px) {
    .cs-container, .cs-title-block, .cs-hero-img-wrap { padding-left: 28px; padding-right: 28px; }
    .cs-deepdive-grid { grid-template-columns: 220px 1fr; gap: 32px; }
  }

  /* ====================== LARGE MOBILE / SMALL TABLET ====================== */
  @media (max-width: 800px) {
    .cs-title-block { padding-top: 36px; }
    .cs-deepdive-grid { grid-template-columns: 1fr; gap: 20px; }
    .cs-sidebar {
      position: static;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      gap: 8px;
      padding-bottom: 6px;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
    }
    .cs-sidebar::-webkit-scrollbar { display: none; }
    .cs-phase-item {
      flex-shrink: 0;
      max-width: 230px;
      white-space: normal;
    }
    .cs-next-phase { text-align: right; }
  }

  /* ====================== MOBILE ====================== */
  @media (max-width: 480px) {
    .cs-container, .cs-title-block, .cs-hero-img-wrap { padding-left: 18px; padding-right: 18px; }
    .cs-title-block { padding-top: 28px; padding-bottom: 20px; }
    .cs-h1 { font-size: 24px; }
    .cs-sub { font-size: 14.5px; }
    .cs-hero-img-wrap { margin-bottom: 36px; }
    .cs-hero-img { height: 220px; border-radius: 0; }
    .cs-section { padding-bottom: 32px; }
    .cs-mini-cta {
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 48px;
    }
    .cs-mini-cta-btn { width: 100%; }
  }
`;